import { render, staticRenderFns } from "./vehicles.vue?vue&type=template&id=50b7f755&"
import script from "./vehicles.vue?vue&type=script&lang=js&"
export * from "./vehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports